var _defs, _g;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgBell(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 13.75,
    height: 16.501
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".bell_svg__cls-1{fill:#fff}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "bell_svg__bell",
    transform: "translate(-2.848 -1)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "bell_svg__Path_31160",
    "data-name": "Path 31160",
    className: "bell_svg__cls-1",
    d: "M15.229 13.452h-.405v-2.466a.758.758 0 10-1.514 0v2.467H5.524V8.12a4.008 4.008 0 013.893-4.106 3.684 3.684 0 011.6.359.743.743 0 001-.4.817.817 0 00-.379-1.056 5.127 5.127 0 00-1.46-.438V1.8a.758.758 0 10-1.514 0v.68A5.617 5.617 0 004.01 8.12v5.332H3.6a.8.8 0 000 1.6h3.067a2.842 2.842 0 002.75 2.448 2.842 2.842 0 002.749-2.452h3.063a.8.8 0 000-1.6zM9.417 15.9a1.283 1.283 0 01-1.189-.855h2.378a1.283 1.283 0 01-1.189.855z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "bell_svg__Path_31161",
    "data-name": "Path 31161",
    className: "bell_svg__cls-1",
    d: "M24.039 7.646H23V6.605a.8.8 0 10-1.6 0v1.041h-1.039a.8.8 0 100 1.6H21.4v1.041a.8.8 0 101.6 0V9.243h1.041a.8.8 0 100-1.6z",
    transform: "translate(-8.24 -2.163)"
  }))));
}

export default SvgBell;